import { Col, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import type { SelectOption, StepAssetsFilterState } from '../../types';
import { normalizeIdArray } from '../../utils';

export interface StepAssetsFiltersProps {
  filters: StepAssetsFilterState;
  onChange: (patch: Partial<StepAssetsFilterState>) => void;
  assetTypeOptions: SelectOption[];
  assetModelOptions: SelectOption[];
  landlordOptions: SelectOption[];
  siteOptions: SelectOption[];
}

export function StepAssetsFilters({
  filters,
  onChange,
  assetTypeOptions,
  assetModelOptions,
  landlordOptions,
  siteOptions,
}: StepAssetsFiltersProps) {
  const { t } = useTranslation('maintenance');

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Select
          mode="multiple"
          allowClear
          showSearch={{ optionFilterProp: 'label' }}
          maxTagCount="responsive"
          style={{ width: '100%' }}
          placeholder={t('wizard.assets.filterByType')}
          value={filters.assetTypeIds}
          options={assetTypeOptions}
          onChange={(value) =>
            onChange({ assetTypeIds: normalizeIdArray(value) })
          }
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Select
          mode="multiple"
          allowClear
          showSearch={{ optionFilterProp: 'label' }}
          maxTagCount="responsive"
          style={{ width: '100%' }}
          placeholder={t('wizard.assets.filterByModel')}
          value={filters.assetModelIds}
          options={assetModelOptions}
          onChange={(value) =>
            onChange({ assetModelIds: normalizeIdArray(value) })
          }
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Select
          mode="multiple"
          allowClear
          showSearch={{ optionFilterProp: 'label' }}
          maxTagCount="responsive"
          style={{ width: '100%' }}
          placeholder={t('wizard.assets.filterByLandlord')}
          value={filters.landlordOrganizationIds}
          options={landlordOptions}
          onChange={(value) =>
            onChange({ landlordOrganizationIds: normalizeIdArray(value) })
          }
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Select
          mode="multiple"
          allowClear
          showSearch={{ optionFilterProp: 'label' }}
          maxTagCount="responsive"
          style={{ width: '100%' }}
          placeholder={t('wizard.assets.filterBySite')}
          value={filters.siteIds}
          options={siteOptions}
          onChange={(value) => onChange({ siteIds: normalizeIdArray(value) })}
        />
      </Col>
    </Row>
  );
}
